import { useRef, useEffect } from 'react';

import { Stack, styled, Box } from '@mui/material';

import { useAnalytics } from '@/analytics/useAnalytics';
import { LocalCapabilityType } from '@/components/AiWorkflow/formSchema';
import {
  featuredTemplatesData,
  FeaturedTemplateType
} from '@/pages/JamiesCapabilities/featuredTemplatesData';

import CapabilitiesTitle from './CapabilitiesTitle';
import FeaturedCard from './FeaturedCard';

const CardsContainer = styled(Stack)({
  flexDirection: 'row',
  gap: '16px',
  width: '100%',
  overflowX: 'auto',
  '& > :last-child': {
    marginRight: '70px'
  }
});

const RightBlur = styled('div')({
  position: 'absolute',
  top: 0,
  right: 0,
  width: 120,
  height: '100%',
  pointerEvents: 'none',
  background: `linear-gradient(270deg, #FBFAF9 9.5%, rgba(251, 250, 249, 0.00) 100%)`,
  zIndex: 1
});

const Container = styled(Stack)({
  width: '100%'
});

const BlurContainer = styled(Box)({
  position: 'relative',
  width: '100%'
});

const FeaturedTemplates = ({
  setEditWorkflow,
  setIsWorkflowOpen
}: {
  setEditWorkflow: (workflow: LocalCapabilityType) => void;
  setIsWorkflowOpen: (isOpen: boolean) => void;
}) => {
  const cardsRef = useRef<HTMLDivElement>(null);
  const { captureEvent } = useAnalytics();

  const handleCardClick = (template: FeaturedTemplateType) => {
    setEditWorkflow(template);
    setIsWorkflowOpen(true);
    captureEvent('agent_template.clicked', { template });
  };

  useEffect(() => {
    const container = cardsRef.current;
    if (!container) return;
    const handleWheel = (e: WheelEvent) => {
      if (e.deltaY === 0) return;
      e.preventDefault();
      container.scrollLeft += e.deltaY;
    };
    container.addEventListener('wheel', handleWheel, { passive: false });
    return () => {
      container.removeEventListener('wheel', handleWheel);
    };
  }, []);

  return (
    <Container>
      <CapabilitiesTitle title="Featured Templates" isFeatured />
      <BlurContainer>
        <CardsContainer ref={cardsRef}>
          {featuredTemplatesData.map(template => (
            <FeaturedCard
              key={template.title}
              template={template}
              onClick={() => handleCardClick(template)}
            />
          ))}
        </CardsContainer>
        <RightBlur />
      </BlurContainer>
    </Container>
  );
};

export default FeaturedTemplates;
